import { createAsyncThunk } from '@reduxjs/toolkit'
import floodServiceAPI, { GetFloodInformationApiProps } from '../../apis/FloodServiceAPI'
import { forceManualRecaptcha, ParcelData, RecaptchaAction } from '../../common/slice'
import { RootState } from '../../common/store'
import { PayloadAction } from '../../common/types'
import RecaptchaRequiredError from '../../errors/RecaptchaRequiredError'
import {STORM_100} from '../../environment';
import {Style} from 'ol/style';
import {GeoLatte} from '../placenames-components/slice';

// Action Types
export const UPDATE_FLOOD_DATA = 'UPDATE_FLOOD_DATA'
export const SELECT_FLOOD_PARCEL = 'SELECT_FLOOD_PARCEL'
export const SWITCH_FLOOD_TAB = 'SWITCH_FLOOD_TAB'
export const SWITCH_FLOOD_LAYER = 'SWITCH_FLOOD_LAYER'

// Selectors
export const getFloodData = (state: RootState) => {
  return state.floodData
}

export const getSelectedTabBase = (state: RootState) => {
  return state.floodTab
}

export const getSelectedFloodLayerBase = (state: RootState) => {
  return state.floodActiveLayer
}

export const getSelectedTab = (state: RootState) => {
  return getSelectedTabBase(state).tab
}

export const getSelectedFloodLayer = (state: RootState) => {
  return getSelectedFloodLayerBase(state).floodLayer
}

// Actions
export const selectFloodParcel = createAsyncThunk(
  SELECT_FLOOD_PARCEL,
  async (floodInformationApiProps: { laisKey: string }, thunkAPI) => {
    try {
      const payload = await floodServiceAPI.getFloodInformationApi(floodInformationApiProps)
      if (payload) {
        thunkAPI.dispatch(updateFloodData(payload))
      }
    } catch (e) {
      if (e instanceof RecaptchaRequiredError) {
        const action: RecaptchaAction<GetFloodInformationApiProps> = {
          type: SELECT_FLOOD_PARCEL,
          payload: floodInformationApiProps,
        }
        thunkAPI.dispatch(forceManualRecaptcha(action))
      } else {
        throw e
      }
    }
  })

export const updateFloodData = (data: FloodInformationData | null) => ({
  type: UPDATE_FLOOD_DATA,
  payload: data,
})

export const switchFloodTab = (tab: string) => ({
  type: SWITCH_FLOOD_TAB,
  payload: tab,
})

export const switchFloodLayer = (floodLayer: string) => ({
  type: SWITCH_FLOOD_LAYER,
  payload: floodLayer,
})


// Types
export interface FloodInformationData extends ParcelData {
  riverineData?: FloodTableData[]
  stormSurgeData?: FloodTableData[]
}

export type FloodDetailsData = {
  [key: string]: number | null
  heightMin: number | null
  heightMax: number | null
  depthMin: number | null
  depthMax: number | null
  velocityMin: number | null
  velocityMax: number | null
}

export interface FloodTableData {
  publishYear: string
  reportReference: string
  floodType: string
  topographyYear: string
  floodDetails: FloodDetailsData
  studyName: string
  event: string
  friendlyName: string
}

type selectedTabState = {
  tab: string | null
}

type selectedFloodLayerState = {
  floodLayer: string | null
}

//Reducers
export const updateFloodDataReducer = (floodInformation: FloodInformationData | null = null, action: PayloadAction<FloodInformationData>) => {
  if (action.type === UPDATE_FLOOD_DATA) {
    return action.payload
  }
  return floodInformation
}

export const floodTabReducer = (state: selectedTabState = { tab: null }, action: PayloadAction<string>) => {
  if (action.type === SWITCH_FLOOD_TAB) {
    state = { ...state, tab: action.payload }
  }
  return state
}

export const floodLayerReducer = (state: selectedFloodLayerState = { floodLayer: STORM_100 }, action: PayloadAction<string>) => {
  if (action.type === SWITCH_FLOOD_LAYER) {
    state = { ...state, floodLayer: action.payload }
  }
  return state
}

export type StyledLayerType = {
    fillColor: string,
    type: string | undefined,
    style: Style,
    className: string,
    data: GeoLatte[]
}
